import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useCompaniesStore } from '../../store';
import { fetchCompanies } from '../../api/companies';

export const CompaniesLoader = ({ children }: { children: React.ReactNode }) => {
    const { data, isLoading, error } = useQuery({
        queryKey: ['companies'],
        queryFn: fetchCompanies,
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
        retry: 2,
    });

    const { setCompanies, setLoading, setError } = useCompaniesStore();

    useEffect(() => {
        if(data) {
            setCompanies(data);
        }

        setError(error ? error.message : null);
        setLoading(isLoading);
    }, [data, isLoading, error, setCompanies, setError, setLoading]);

    return <>{children}</>;
};